import script from "./WalletComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletComponent.vue?vue&type=script&setup=true&lang=js"

import "./WalletComponent.vue?vue&type=style&index=0&id=27d927f6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27d927f6"]])

export default __exports__